import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { ICheckboxField, IFormFieldOption } from '@shared/interfaces';

@Component({
  selector: 'app-checkbox-section',
  templateUrl: './check-box-section.component.html',
  styleUrls: ['./check-box-section.component.scss'],
  standalone: false,
})
export class CheckBoxSectionComponent implements OnInit {
  @Input() field!: ICheckboxField;
  @Input() control!: FormControl<string[]>;
  @Output() valueChange = new EventEmitter<string[]>();

  ngOnInit() {
    // Initialize with default selected values
    const initialValues = this.field.options
      .filter((opt) => opt.isSelected)
      .map((opt) => opt.value);

    if (!this.control.value) {
      this.control.setValue(initialValues);
    }
  }

  onCheckboxChange(event: MatCheckboxChange, option: IFormFieldOption) {
    const currentValues: string[] = this.control.value || [];

    if (event.checked) {
      if (!currentValues.includes(option.value)) {
        currentValues.push(option.value);
      }
    } else {
      const idx = currentValues.indexOf(option.value);
      if (idx > -1) currentValues.splice(idx, 1);
    }

    option.isSelected = event.checked;
    this.control.setValue([...currentValues]);
    this.valueChange.emit([...currentValues]);
  }
}
